var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"rich-title mb-7"},[_vm._t("title")],2),_c('div',[_c('app-editor',{ref:"editor",attrs:{"editable":false,"value":_vm.body}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }